import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, InputLabel, ListItem, Paper, Radio, Snackbar, SnackbarContent, Typography } from '@mui/material';


import AbEnvironment from '../auth/AbEnvironment';
import FundingSourceTile from './FundingSourceTile';
import CurrencyTextField from '../ui/CurrencyTextField';
import LoadingSpinner from '../ui/LoadingSpinner';
import SavingSpinner from '../ui/SavingSpinner';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import { AccountBalance } from '@mui/icons-material';
import ServerError from '../ui/ServerError';
import AppBindStyles from '../../AppBindStyles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import classNames from 'classnames';
import { green } from '@mui/material/colors';

const abEnvironment = new AbEnvironment();

const AddWalletFundsFormQuery = graphql`
query AddWalletFundsFormQuery($accountId: UUID!, $activeOnly: Int, $purpose: Int) {
  paymentsourceswithaggregate7(accountid: $accountId, activeonly: $activeOnly, purpose: $purpose) {
    totalCount
    nodes {
      psId
      psType
      psStatus
      paidMtd
      paidLastMonth
      paidYtd
      paidLifetime
      ccBrand
      ccLast4
      ccExpy
      fiName
      achAccountNum
      firstName
      lastName
      extSource
      extPsId
      paypalEmail
      maxPsOrder
      maxPsOrderIn
      psStatusOther
      declineCount
      lastDeclineReason
      lastDeclineChargeAmount
    }
  }
  accountTByAccountId(accountId: $accountId) { accountId accountType achLimitNopeek achLimitAbsolute  walletTsByAccountId { nodes { walletId }} paymentSourceTsByAccountId {nodes { psId plaidAccessToken } } }
  getaccountledgersummary(accountId: $accountId, balancedate: null) {
    maxPayoutBalance
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  flex: {
    flex: 1,
  },
  paper: {
    textAlign: 'left',
    //color: theme.palette.text.secondary,
    maxWidth: 1122,
    marginTop: 16,
    marginBottom: 16,
    paddingTop: 16,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
  },
  dbTile: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 56,
    width: 264
  },
  dbTileSelected: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 56,
    width: 264,
    backgroundColor: '#D3D3D3'
  },
  dbTileNonSelectable: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 312
  },
  success: {
    backgroundColor: green[300],
  },
  error: {
    backgroundColor: theme.palette.error.light,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    padding: theme.spacing(0.5),
  },   
});

class AddWalletFundsForm extends React.Component {
  state = {
    accountId:    this.props.accountId,

    addFundsSpinner: false,
    topOffAmount: 30,
    topOffAccount: null,
    saveStatusAddNow: null,
    saveMessageAddNow: null,
    saveSnackbarOpenAddNow: false,
    saveSnackbarDurationAddNow: null,
    showTopOffDialog : false
  }


  handleSnackbarClose = (event, reason) => { 
    this.setState({ saveSnackbarOpenAddNow: false, saveStatusAddNow: '', saveMessageAddNow: '' });
  };

  showTopOffDialog(singlePS, account) {

    let psId = this.state.topOffAccount;
    if (psId === null) {
      psId = singlePS.psId;
    }
    let amount = this.state.topOffAmount;

    let plaidTokenAvailable = false;
    for (var i=0; i< account.paymentSourceTsByAccountId.nodes.length; i++) {
      let n = account.paymentSourceTsByAccountId.nodes[i];
      if (n.psId === psId) {
        if (n.plaidAccessToken) {
          plaidTokenAvailable = true;
        }
      } 
    }

    if (plaidTokenAvailable) {
      if (Number(amount) > Number(account.achLimitAbsolute)) {
        this.setState({ addFundsSpinner: false, saveSnackbarOpenAddNow: true, saveStatusAddNow: 'error', saveMessageAddNow: 'Amount is over the maximum allowed', saveSnackbarDurationAddNow: null  });
        return;
      }
    } else {
      if (Number(amount) > Number(account.achLimitNopeek) ) {
        this.setState({ addFundsSpinner: false, saveSnackbarOpenAddNow: true, saveStatusAddNow: 'error', saveMessageAddNow: 'Amount is over the maximum allowed', saveSnackbarDurationAddNow: null  });
        return;
      }
    }

    this.setState({ showTopOffDialog: true })
  }

  balanceSelected(maxPayoutBalance, acctId) {
    if (maxPayoutBalance < 30) {
      this.setState({ topOffAccount: acctId, topOffAmount: maxPayoutBalance }) 
    } else {
      this.setState({ topOffAccount: acctId }) 
    }
  }

  disablePayNow(maxPayoutBalance, acctId) {

    if (this.state.topOffAmount === '') {
      return true;
    }

    //allow any positive amount to be transfered from account
    if (this.state.topOffAccount === acctId) {
      if (parseFloat(this.state.topOffAmount) > 0 && parseFloat(this.state.topOffAmount) <= maxPayoutBalance) {
        return false;
      } else {
        return true
      }
    }
    let topupAmount = parseFloat(this.state.topOffAmount);
    if (topupAmount < 30) {
      return true;
    }
    return false;
  }

  getTopupAmountErrorMessage(maxPayoutBalance, acctId) {
    let errMesg = null;

    if (this.state.topOffAmount === '') {
      errMesg = 'Please enter an amount'
    }

    if (this.state.topOffAccount === acctId) {
      if (parseFloat(this.state.topOffAmount) <= 0) {
        errMesg = 'Amount cannot be zero';
      } else if (parseFloat(this.state.topOffAmount) > maxPayoutBalance) {
        errMesg = 'Amount cannot be greater than available earnings'
      } 
    } else {
      let topupAmount = parseFloat(this.state.topOffAmount);
      if (topupAmount < 30) {
        errMesg = 'Amount cannot be less than 30';
      }
    }
    return errMesg;
  }

  isTopupAmountError(maxPayoutBalance, acctId) {
    if (this.getTopupAmountErrorMessage(maxPayoutBalance, acctId) == null) {
      return false;
    }
    return true;
  }

  render() {
    const classes = this.props.classes;

    const { logError } = this.props.auth;
    let acctId = this.props.accountId;

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={AddWalletFundsFormQuery}
        variables={{accountId: acctId,
                    activeOnly: 1,
                    purpose: 0}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {

            let paymentSourceCount = 0;
            if (props.paymentsourceswithaggregate7 != null && props.paymentsourceswithaggregate7.totalCount > 0) {
              //there is a header row that we do not want counted as a payment source.
              paymentSourceCount = props.paymentsourceswithaggregate7.totalCount - 1;
            }

            let actives = [];
            let activeCounter = -1;


            if (paymentSourceCount) {
              //this starts at 1 because there is a header row
              for (var i=1; i<props.paymentsourceswithaggregate7.nodes.length; i++) {
                let n = props.paymentsourceswithaggregate7.nodes[i];
                if (n.psStatus === 0) {
                  actives.push(n);
                } 
              }
            }
            let maxPayoutBalance = Number(props.getaccountledgersummary.maxPayoutBalance);
            let maxPayoutBalanceDisplay = Number(maxPayoutBalance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

            let singlePS = null;
            if (actives.length === 1 && !(maxPayoutBalance > 0 && props.accountTByAccountId.accountType === 3 )) {
              singlePS = actives[0];
            }

            let selectedPsId = this.state.topOffAccount;
            if (selectedPsId === null) {
              if (singlePS) {
                selectedPsId = singlePS.psId;
              }
            }

            let transferString =  'Your funding source will be charged and your account will be topped up immediately.  Are you sure you want to proceed?';
            if (selectedPsId === acctId) {
              transferString = 'Your funds will be transfered from your account.  Are you sure you want to proceed?'
            } 

            return (
              <div>
                <Paper className={classes.paper}>
                  <Grid container spacing={2} direction="row" >
                    <Grid item xs={12}>
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Grid container spacing={0}>
                            <Grid item>
                              <Typography align="left" variant="h6">Add expense wallet funds</Typography>
                            </Grid>                          
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <CurrencyTextField id="top-off-amount" label="Add" className={classes.currencyField}
                                value={this.state.topOffAmount}
                                onChange={(e) => this.setState({ topOffAmount: e.target.value })}
                                showErrMsg={true}
                                error={this.isTopupAmountError(maxPayoutBalance, acctId)}
                                errorMsg={this.getTopupAmountErrorMessage(maxPayoutBalance, acctId)}
                                allowNegative={false}
                                minValue={0}
                                minEnterValue={0}
                                textAlign="right"
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <InputLabel shrink>From funding source</InputLabel>
                            </Grid>
                            {(maxPayoutBalance > 0) && (props.accountTByAccountId.accountType === 3) &&
                             
                                <ListItem className={classes.radioListItem} key={activeCounter}>
                                  <Radio
                                    checked={this.state.topOffAccount === acctId || singlePS !== null}
                                    onClick={() => { this.balanceSelected(maxPayoutBalance, acctId) }}
                                    name='payment-source-rb'
                                    
                                  />
                                  <Paper className={((this.state.topOffAccount === acctId || singlePS !== null) ? classes.dbTileSelected : classes.dbTile)} onClick={() => { this.balanceSelected(maxPayoutBalance, acctId)  }}>
                                    <Grid container alignItems="center">
                                      <Grid item style={{paddingTop:'12px', paddingLeft: '16px', paddingRight: '36px'}}>
                                        <AccountBalance color="primary" fontSize="large"/>
                                      </Grid>
                                      <Grid item style={{paddingTop:'12px', paddingRight: '8px'}}>
                                        <Typography variant="subtitle2" display="block" align="left">{'Available earnings balance'}</Typography>
                                          <Typography variant="caption" display="block" align="left" >{maxPayoutBalanceDisplay}</Typography>
                                        </Grid>                              
                                    </Grid>
                                  </Paper>
                                </ListItem>
                             
                            }
                            {actives.map(n => {
                              activeCounter++;
                              return (
                                <ListItem className={classes.radioListItem} key={activeCounter}>
                                  <Radio
                                    checked={this.state.topOffAccount === n.psId || singlePS !== null}
                                    onClick={() => { this.setState({ topOffAccount: n.psId })  }}
                                    name='payment-source-rb'
                                    
                                  />
                                  <Paper className={((this.state.topOffAccount === n.psId || singlePS !== null) ? classes.dbTileSelected : classes.dbTile)} onClick={() => { this.setState({ topOffAccount: n.psId })  }}>
                                    <FundingSourceTile 
                                      psType={n.psType}
                                      ccBrand={n.ccBrand}
                                      ccLast4={n.ccLast4}
                                      ccExpy={n.ccExpy}
                                      fiName={n.fiName}
                                      achAccountNum={n.achAccountNum}
                                      firstName={n.firstName}
                                      lastName={n.lastName}
                                      paypalEmail={n.paypalEmail}
                                      declineCount={n.declineCount}
                                      lastDeclineReason={n.lastDeclineReason}
                                      lastDeclineChargeAmount={n.lastDeclineChargeAmount}
                                    />
                                  </Paper>
                                </ListItem>
                              )
                            })}
                            <Grid item xs={12}>
                              <Grid container direction="row" justifyContent="flex-start" style={{paddingTop: '16px'}}>
                                <Grid item>
                                  {!this.state.addFundsSpinner &&
                                  <Button color="primary" variant="contained" style={AppBindStyles.bottomButton} disabled={(this.state.topOffAccount === null && singlePS === null) || this.disablePayNow(maxPayoutBalance, acctId) }
                                          onClick={(e) => this.showTopOffDialog(singlePS, props.accountTByAccountId)}>
                                    Add funds
                                  </Button>
                                  }
                                  {this.state.addFundsSpinner &&
                                  <Button color="primary" variant="outlined" style={AppBindStyles.bottomButton}>
                                    <SavingSpinner/>
                                  </Button>
                                  }
                                </Grid>
                                <Grid item>
                                  <Button color="primary" variant="outlined" style={AppBindStyles.bottomButton}
                                          onClick={(e) => this.props.onClose() }>
                                    Cancel
                                  </Button>

                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
                { /* this.topOffAccount(); */}
                <ConfirmationDialog
                    open={this.state.showTopOffDialog}
                    onClose={() => { this.setState({showTopOffDialog:false});}}
                    onConfirm={() => { this._doTopUp(singlePS, props.accountTByAccountId); }}
                    onCancel={() => { }}
                    irreversibleAction={true}
                    title="Top up account"
                    cancelBtn="Cancel"
                    okBtn="Ok"
                >
                  {transferString}
                </ConfirmationDialog>  

                <Snackbar
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                        }}
                        open={this.state.saveSnackbarOpenAddNow}
                        onClose={this.handleSnackbarClose}>
                        <SnackbarContent
                          className={classNames(classes.message, classes[this.state.saveStatusAddNow])}
                          onClose={this.handleSnackbarClose}
                          message={
                            <Typography variant="body1">
                                {this.state.saveMessageAddNow}
                            </Typography>
                          }
                          action={[
                            <IconButton
                              key="close"
                              aria-label="Close"
                              color="inherit"
                              className={classes.close}
                              onClick={this.handleSnackbarClose}
                              size="large">
                            <CloseIcon />
                          </IconButton>
                        ]}
                      />
                    </Snackbar>

              </div>
            );
          }
          return <div><LoadingSpinner/></div>
        }}
      />
    );

  }

  _doTopUp(singlePS, accountTByAccountId) {

    let psId = this.state.topOffAccount;
    if (psId === null) {
      psId = singlePS.psId;
    }
    if (psId === accountTByAccountId.accountId) {
      //balance transfer
      this._initiateTransfer(accountTByAccountId);
    } else {
      this._topUpAccount(psId, accountTByAccountId)
    }

  }

  _initiateTransfer(accountTByAccountId) {
    const { callPartnerApi } = this.props.auth;
    let walletId = accountTByAccountId.walletTsByAccountId.nodes[0].walletId;

    let stringAmt = Number(this.state.topOffAmount).toString()

    this.setState({executingPayout: true});

    let aPjwt = abEnvironment.getPjwt();

    let payload = {
      operation: "transferAccountAssetWalletAsset",
      params: {
        pJwt: aPjwt,
        accountId: this.props.accountId,
        walletId: walletId,
        transferAmount: stringAmt,
        direction: 0
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {

      let abpResponse = response.data;
      if (abpResponse.result.statusCode === 0) {
        this.setState({ saveSnackbarOpenAddNow: true, saveStatusAddNow: 'success', saveMessageAddNow: 'Transfer successful', saveSnackbarDurationAddNow: null });
        window.location.reload();
      } else {
        this.setState({ saveSnackbarOpenAddNow: true, saveStatusAddNow: 'error', saveMessageAddNow: 'There was a problem with transfer.  Please contact AppBind support.', saveSnackbarDurationAddNow: null });
      }
    })
 
    .catch(error => {
      let theErrorText = "Unidentified Error";

      let abpResponse = error.data;
      if (abpResponse != null && abpResponse.message != null) {
        theErrorText = abpResponse.message;
      }
      this.setState({ saveSnackbarOpenAddNow: true, saveStatusAddNow: 'error', saveMessageAddNow: theErrorText, saveSnackbarDurationAddNow: null });
    });
  }


  _topUpAccount(psId, accountTByAccountId) {

    let walletId = accountTByAccountId.walletTsByAccountId.nodes[0].walletId;


    this.setState( {addFundsSpinner: true}); 

    const { callPartnerApi } = this.props.auth;

    let usingAccountId = this.props.accountId;
    let pAccountId = abEnvironment.getUserAttribute('a_id');
    let atId = 'f5c70f86-135a-11e8-bb45-97ef56920c02'
    let amount = this.state.topOffAmount;

    /*
    if (theAmount != null) {
      amount = theAmount;
      description = 'AutoTopup transaction';
    }
    */

    let payload = {
      operation: "getPlaidBalance",
      params: {
        accountId:           usingAccountId,
        psId:                psId,
        amount:              amount
      }
    }
    
    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    ).then(response => {
      return response.json();
    })
    .then(data => {


      //plaid is reporting enough funds
      if (data.status === 1) {
        let payload = {
          operation: "processWalletTopUp",
          params: {
            usingAccountId:           usingAccountId,
            psId:                     psId,
            provisioningAccountId:    pAccountId,
            atId:                     atId,
            amount:                   amount,
            description:              "Wallet topup transaction",
            walletId:                 walletId
          }
        }
        return callPartnerApi('appbind/generic',
                              'POST',
                              payload);
      } else {
        data.status = 2;  //for a different message to end user below
        throw data;
      }


    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      if (data.status !== 0) {
        throw data;
      } else {
        this.setState({ saveSnackbarOpenAddNow: true, saveStatusAddNow: 'success', saveMessageAddNow: 'Account updated', saveSnackbarDurationAddNow: 3000 });
        window.location.reload();
      }
    })
    .catch(error => {
      //console.log('Got error: ' + error);
      if (error.status && error.status === 2) {
        this.setState({ addFundsSpinner: false, saveSnackbarOpenAddNow: true, saveStatusAddNow: 'error', saveMessageAddNow: 'Your bank is indicating not enough in account to complete transaction', saveSnackbarDurationAddNow: null  });
      } else {
        this.setState({ addFundsSpinner: false, saveSnackbarOpenAddNow: true, saveStatusAddNow: 'error', saveMessageAddNow: 'Problem adding funds', saveSnackbarDurationAddNow: null  });
      }
    });
  }
  
}

/*
AddWalletFundsForm.propTypes = {
  classes: PropTypes.object.isRequired,
};
*/
export default withStyles(styleSheet)(AddWalletFundsForm);
